module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "cn"
  }, [_vm._v("Chapter One Colonial Connecticut")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('big', [_vm._v("W")]), _vm._v("ith the growth of the Connecticut colony in the seventeenth century, a network of local, inter-town, and intercolony roads developed, poor though they were, and the first ferry and bridge crossings appeared. Since most towns did not set land aside for roads, the laying out of roads was a troublesome process. Likewise, since these early agricultural communities were largely self-sufficient, inter-town roads were often reluctantly built and poorly maintained. With the establishment of the Post Road from New York to Boston in the 1690s, communication improved along three post routes through Connecticut, which together became the backbone of intertown transportation in and through the colony. The eighteenth century brought increased travel, and the construction of additional roads, ferries, and bridges, as Connecticut moved away from its Puritan roots and toward a secular society in which small-scale manufacturing and market capitalism were on the rise.")], 1)]), _vm._m(0), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Because travel by ship was the principal means of transportation for the early colonists, most of these first settlements were readily accessible by water. Indeed, the original settlement of river towns such as Hartford and New London included land on both sides of the Connecticut and Thames rivers respectively, thereby incorporating the waterway directly into the community.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The second phase of settlement lasted from 1686 to 1734, during which time twenty-eight new towns were founded. Here, colonists moved into the Windham Hills of the eastern uplands and, to a lesser degree, the southwest hills of the western uplands, with all but seven of the new towns being founded east of the Connecticut River. The defeat of the Ninnimissinuwocks in King Phillip’s War allowed settlers to occupy these two upland regions without fear of reprisal.")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._m(5), _vm._m(6), _vm._m(7), _vm._m(8), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }), _vm._v(" "), _c('h4', {
    staticClass: "head1"
  }, [_vm._v("Early Roads, Ferries, and Bridges")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There were two main types of roadways in the Connecticut colony: town ways, or roads that led to various locations within a given town, and country ways, or roads that connected each town to neighboring settlements. Town ways were further subdivided into two kinds: public town ways that were of benefit to the entire community, such as the road to the local gristmill or sawmill; and private town ways that were of benefit to an individual landowner, such as a road to a farmer’s pasture or woodland. Since early Connecticut towns were founded with little consideration for growth, and with no land set aside for roadways of any type, the laying out of early colonial roads was often a cumbersome process.")]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Providing for private town ways, which were numerous in an agricultural community, was more troublesome. Most early towns were founded as Puritan villages, with a central green and church and a wide main street, along which were situated home lots for the community’s founding members. Beyond this residential core were farmlands, grazing pastures, and woodlands, portions of which were assigned to every household. Within this configuration, private town ways were laid out under the direction of the town selectmen so as to allow each family access to their outlands while causing minimal impact to the property of other inhabitants.")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Road building in the colony was accomplished through the English system of statute labor, under which every man aged sixteen to sixty and his team of horses or oxen were required to labor one day each year on the roads in his town. Within each town, roadwork was supervised by one or more town-appointed surveyors, who were responsible for the participation of the men in their district. The work was compulsory; neither laborer nor overseer was paid for his efforts, and both were subject to a fine for failing to perform their duties. Likewise, the General Court could fine any town that neglected its road-building obligations.")]), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Once a road was established, maintenance was never-ending, and involved the repeated repair of ruts and mires caused by rain and ice, the twin enemies of all New England roadways. Given these facts of colonial road building, it should be no surprise that travel by sleigh after a heavy winter snowfall often provided colonists with the best travel conditions of the year.")]), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._m(23), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _c('h4', {
    staticClass: "head1"
  }, [_vm._v("THE KING’S BEST HIGHWAY")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("From the first years of settlement, travel between the English colonies in North America was prompted by the need for the sharing of information among government officials. As early as May 1638, the English colonies of New England petitioned King Charles I for the authority to establish a postal service in the new world, but their request was denied. By 1659, however, correspondence between Governor John Winthrop of Connecticut and officials in Massachusetts indicated that a makeshift postal service existed at that time that relied on trusted emissaries who were willing to “adventure through the wilderness” on the weeklong, one-way journey. But it was not until after the restoration of King Charles II in 1660 and the fall of New Amsterdam (New York) to the English in 1664 that the new governor of New York, Francis Lovelace, was instructed by Charles II to improve communication among the English colonies, in particular between New York and the colonies of New England. To this end, Lovelace and Governor Winthrop agreed to establish a regular post service between New York and Boston via New Haven and Hartford, “consonant to the commands of His sacred Majestie, who strictly injoins all his American subjects to enter into a close correspondency with each other.”")]), _vm._v(" "), _vm._m(33), _vm._m(34), _vm._m(35), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }), _vm._v(" "), _vm._m(36), _vm._v(" "), _vm._m(37), _vm._v(" "), _vm._m(38), _vm._v(" "), _vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _vm._m(41), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._m(42), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In addition to his mail-related duties, a post rider was expected to act as a travel guide for anyone who wished to accompany him. One such person was Sarah Kemble Knight, a twice-widowed shopkeeper’s daughter from Boston who at the age of thirty-eight traveled the lower Post Road to New York in 1704. Frightened of water travel, Sarah Knight chose horseback for her trip to New York to settle the estate of her deceased second husband. After she left Boston in the afternoon of October 2, it took Knight three days to reach the Pawcatuck River and cross into Connecticut. Her observations of her travels through the colony, recorded in a daily journal, provide a firsthand look at the difficult travel conditions that still existed along the lower post road in eastern Connecticut six years after the order of the General Court:")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }), _vm._v(" "), _c('p', {
    staticClass: "ext-para"
  }, [_vm._v("Thursday, October 5th: I Ridd on very slowly thro’ Stoningtown, where the Rode was very Stony and uneven. …  Here I heard there was an old man and his Daughter to come that way, bound to N. London; and being now destitute of a Guide, gladly waited for them. …  About seven that Evening, we come to New London Ferry: here, by reason of a very high wind, we mett with great difficulty in getting over—the boat toss’t exceedingly, and our Horses capper’d at a very surprising Rate, and set us all in a fright. …  Being safely arrived … in N. London, I treated neighbor Polly and daughter for their divirting company, and bid them farewell.")]), _vm._v(" "), _vm._m(43), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._m(44), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }), _vm._v(" "), _vm._m(45), _vm._v(" "), _c('h4', {
    staticClass: "head1"
  }, [_vm._v("Eighteenth-Century Expansion")]), _vm._v(" "), _vm._m(46), _vm._m(47), _vm._m(48), _vm._v(" "), _vm._m(49), _vm._v(" "), _vm._m(50), _vm._v(" "), _vm._m(51), _vm._v(" "), _vm._m(52), _vm._v(" "), _vm._m(53), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Overall, the quality of country roads in Connecticut was still less than adequate, and could vary considerably from route to route, or from town to town along a given route. John Fitch, the Windsor native who later gained neither fame nor fortune as an inventor of the steamboat, told of a road gang incident of his youth that gives us a picture of colonial life in the 1750s, as well as an appreciation for the role of rum in road-building:")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }), _vm._v(" "), _vm._m(54), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }), _vm._v(" "), _vm._m(55), _vm._v(" "), _vm._m(56), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._m(57), _vm._v(" "), _vm._m(58), _vm._v(" "), _vm._m(59), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As the need for longer and stronger bridges became apparent, dependence on statute labor for their construction became impractical. Instead, towns looked to local or itinerant artisans to build their bridges for them, and such bridge builders needed to be paid. However, the useful life of a timber bridge built during the colonial period was only seven to ten years, by which time damage from weathering, ice flows, and spring floods (and from sea worms to bridges on wooden pilings) had taken their toll. This meant that after a bridge was built, finding funds for reconstruction remained an ongoing worry for town officials, particularly in communities with several crossings, or a span of considerable length.")]), _vm._v(" "), _vm._m(60), _vm._v(" "), _vm._m(61), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A second means of paying for bridge construction that was used more widely as the century wore on was to allow the person who constructed a bridge to collect a toll for its use. The idea was first utilized in Connecticut with the construction of a stone arch bridge in Middletown in 1697. The colony’s second toll bridge was built in Plainfield in 1728. Toll bridge crossings were authorized and regulated by the General Assembly.")]), _vm._v(" "), _vm._m(62), _vm._v(" "), _vm._m(63), _vm._v(" "), _vm._m(64), _vm._v(" "), _vm._m(65), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._m(66), _vm._v(" "), _vm._m(67), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Throughout the eighteenth century, Connecticut towns made use of these various financing methods—barter, toll, lottery, and the occasional tax levy— to construct and maintain the bridges in their communities, often using one method to build a bridge and another to fund its repair or reconstruction. Meanwhile, towns that had little need for expensive bridge crossings considered themselves blessed by circumstance.")]), _vm._v(" "), _vm._m(68), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The upper, middle, and lower post roads through Connecticut remained the triune spine of the colony’s intertown road network throughout the eighteenth century. But as traffic increased, variations appeared in each route to service new towns, or to make travel easier overall. On the upper Post Road, a detour from the New Haven to Hartford route veered east from North Haven through Durham, Middletown, and Cromwell and rejoined the old route in Wethersfield. Along the middle post road to Boston, a more direct route was established through Mansfield, Pomfret, and Thompson, south of the existing road.")]), _vm._v(" "), _vm._m(69), _vm._v(" "), _vm._m(70), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In November 1773, Hugh Finlay, the surveyor of all the king’s highways in North America, traveled through Connecticut as part of an inspection tour of postal operations in New England. Traveling from Newport to New London along the stretch of roadway that had so troubled Madam Knight seven decades before, Finlay noted:")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }), _vm._v(" "), _c('p', {
    staticClass: "ext-para"
  }, [_vm._v("Continued my route towards New London where I expected to arrive in the evening, but I found the road past all conception bad so that from daybreak until sunset I made but 33 miles and put up at a little tavern 4 mile east of New London. The road is one continued bed of rocks and very hilly. It is impossible for a Post to ride above 4 mile an hour in such road, and to do even that he must have a good horse, one used to such a rocky path.")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Not only had conditions not changed in three-quarters of a century, in Finlay’s opinion the post road in this location was “on the whole the most difficult and as dangerous as any in America.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Continuing to New Haven, Finlay was further inconvenienced when the post rider he hoped to meet in New London was delayed. Finlay suspected that the rider’s tardiness was caused by the personal business he was conducting along the way, and as he rode on ahead without him, his suspicion was confirmed by people who inquired of Finlay “if I had not met the Post driving some oxen; it seems he had agreed to bring some along with him.”")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }), _vm._v(" "), _vm._m(71), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Finlay’s assessment of John Hurd of Stamford, New England’s most famous post rider, suggests the growing volume of business being transacted in the colony, while his description of the lower post road through New London county is weighty testimony to the poor travel conditions still to be encountered in portions of Connecticut late in the eighteenth century.")]), _vm._v(" "), _c('h4', {
    staticClass: "head1"
  }, [_vm._v("FREIGHT WAGONS AND STAGECOACHES")]), _vm._v(" "), _vm._m(72), _vm._v(" "), _vm._m(73), _vm._v(" "), _vm._m(74), _vm._v(" "), _vm._m(75), _vm._v(" "), _c('h4', {
    staticClass: "head1"
  }, [_vm._v("From Colony to Nation")]), _vm._v(" "), _vm._m(76), _vm._v(" "), _vm._m(77), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Following the defeat of the French in 1763 and their expulsion from colonial North America, England found itself with an overseas colony that stretched from the Atlantic seaboard west to the Mississippi River, a territory that was as costly to maintain as it was vast. After generations of salutary neglect by the mother country, during which time the English colonies, Connecticut in particular, had been allowed considerable freedom in the conduct of their affairs, the British government under George III began a policy of strict oversight of trade, while enacting revenue-raising measures such as the Stamp Act, the Townsend Act, and the Tea Act to help pay for their American empire. With each new act, the colonists stiffened their resistance, as they sought to retain the autonomy and economic prosperity they were accustomed to. By April 1775, when news of the armed skirmishes between British troops and colonial militia at Lexington and Concord reached New Haven, what had begun as a rebellion against unfair taxes and trade restrictions had become a revolution for political and economic independence.")]), _vm._v(" "), _vm._m(78), _vm._v(" "), _vm._m(79), _vm._v(" "), _vm._m(80), _vm._v(" "), _vm._m(81), _vm._v(" "), _vm._m(82), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _vm._m(83), _vm._v(" "), _vm._m(84), _vm._v(" "), _vm._m(85), _vm._v(" "), _vm._m(86), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }), _vm._v(" "), _vm._m(87), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Of all these roads, the three-pronged upper, middle, and lower post roads from New York to Boston, together with the high road to Albany northwest from Hartford, provided the main transportation corridors linking the new state of Connecticut to the independent nation of which it was one small part.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Also by 1800, the European-style economy of Connecticut had grown to sustain a population of more than 250,000 persons (almost entirely of English descent) who were distributed more or less evenly over the largely agricultural landscape. Yet within this cultivated English garden, the seeds of diversification and urbanization had already been planted. In 1784, the municipalities of New Haven, New London, Hartford, Middletown, and Norwich were incorporated as the state’s first cities, a clear indication that the evolving civic interests of the merchant class in those ports had become of greater relative importance than the traditional needs of local farmers.")]), _vm._v(" "), _vm._m(88), _vm._v(" "), _vm._m(89), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _vm._m(90), _vm._v(" "), _vm._m(91), _c('a', {
    attrs: {
      "id": "page_47"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('h4', {
    staticClass: "head1"
  }, [_vm._v("Settlement of the Connecticut Colony")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('i', [_vm._v("The pattern of settlement and the process of town founding, along with the colony’s geographic position in southern New England, were strong influences on the evolution of transportation in colonial Connecticut.")])]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("During the first 140 years of English colonization, the land was brought under English control and governance in three phases. Settlers and their offspring moved first into the fertile lands of the central valley and coastal slopes, then inland across the eastern highlands and southwestern hills, and lastly into the colony’s northwest hills, until all the land within the bounds of Connecticut was in English hands. Given the importance of agriculture to the early colonists, the first regions settled contained the colony’s best farmland, while subsequent phases of settlement corresponded to geomorphic regions of decreasing agricultural productivity.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("The first phase of settlement began in the 1630s and extended to the conclusion of King Philip’s War in 1675. In this phase, towns were established throughout the central valley, along the coast of Long Island Sound west and east of New Haven, and within the lower reaches of the Connecticut, Housatonic, and Thames river valleys. A total of twenty-five towns were founded in this period, each containing some of the most arable farmland within the colony. So thorough was the search for good farmland that colonists in this first phase discovered and settled the secluded Pomperaug Valley of Wood-bury, an area within the southwest hills whose soil, by geologic happenstance, was as productive as that of the Connecticut River valley. By 1680, Connecticut colonists reported to their superiors in England: “Most land that is fit for planting is taken up. What remains must be subdued, and gained out of the fire as it were by hard blows and for small recompense.”"), _c('sup')]), _c('a', {
    attrs: {
      "id": "ch01en1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("During the third phase of settlement, from 1737 to 1761, the northwest hills—where topsoil was thinnest—were settled, with the founding of fifteen new towns. The established towns of Suffield, Enfield, Somers, and Woodstock, which had been settled as part of Massachusetts, were placed under Connecticut jurisdiction, thereby rounding out the colony’s borders. From this point forward, all new towns in the colony (and state) of Connecticut would be carved from the landholdings of these seventy-two original English settlements."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The impetus behind the founding of new towns was population growth. Following the arrival of the first settlers during the Great Migration of 1630–42, Connecticut’s population grew almost exclusively through natural in crease. Growth was rapid, and large family size was the norm, with families of eight or more children not uncommon. What was a fledgling colony of four thousand English souls in 1650 reached a population of twenty-six thousand by 1700. By the time the third phase of settlement came to a close, the population of the Connecticut colony exceeded 150,000 persons."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img_18.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img_19.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('i', [_vm._v("Windham town plan, 1686. The original layout of many colonial towns made local roads difficult to construct, especially once outlying areas became populated. (Map Collection, Connecticut State Library)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Under its charter of 1662, the governance of Connecticut was directed by a General Court (later called General Assembly) that consisted of the colony’s governor, a governor’s council of twelve magistrates, and two deputy representatives from each town. Any action of the General Court, from town founding and tax collection to the establishment of roads and ferries, required the majority approval of both the magistrates and the deputies. A Court of Assistants (later called the Superior Court) composed of the governor or deputy governor and four designated magistrates, conducted the judicial business of the colony, since Connecticut’s colonial charter did not provide for a separation of powers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Following the merger of the New Haven and Connecticut colonies, the General Court created Connecticut’s first four counties in 1666, with county seats in Hartford, New Haven, Fairfield, and New London. Each county had its own court, where certain judicial matters, including road-building disputes, were handled at an intermediate level. As settlement spread to the eastern and western hills, additional counties were established at Windham (1726), Litchfield (1751), Tolland (1785), and Middlesex (1785).")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Rounding out a trilevel system of colonial government was a variety of locally elected officials who ran the affairs of each town. These officials included a board of selectmen who managed town affairs; a lister, to compile a record of the taxable property in each town; one or more constables to collect the taxes, and monitor mischief; and one or more surveyors to oversee the construction and maintenance of roads and bridges within each town.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("While the general and county courts provided a combination of executive, legislative, and judicial guidance for the colony—from authorizing the incorporation of new towns to passing the laws of the colony and adjudicating disputes between towns—it was the individual towns, and the men who ran them, who were charged with executing and financing the responsibilities passed on to them by the general and county courts. Guiding each level of colonial governance in its various functions was the tradition of English law that the settlers brought with them from their old world to the new."), _c('sup')]), _c('a', {
    attrs: {
      "id": "ch01en4"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("With regard to transportation matters, the General Court’s policy of town founding strongly influenced the colony’s transportation infrastructure. The establishment of separate towns, each with its own civil authority, was a natural response to the demand for new lands to settle, but the result was a patchwork of numerous communities, of more or less equal size, spread out over the landscape, with most town centers having no more than eight miles between them."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" This pattern of multiple population centers required a larger network of intertown roads relative to the land area of the colony than might otherwise have been the case. Together with the colony’s surface topography, this pattern of multiple population centers, imposed on the land by the General Court, remained an important influence on the development of transportation routes within Connecticut throughout the colonial period.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "para"
  }, [_c('i', [_vm._v("By 1700, a crude yet adequate network of roads, ferries, and bridges had appeared in the Connecticut colony.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "head2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TOWN WAYS AND COUNTRY ROADS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("A request for the construction of a public town way was typically discussed in an open town meeting. If the town’s selectmen decided that the road petitioned for was necessary, a committee was appointed to lay out its route, after which compensation was set for those whose land would be taken, with the understanding that the affected landowners could appeal the damage payment to the county court if they thought it unjust. If the request for a public town way was denied, the petitioner could appeal the decision to the county court, and ultimately to the General Court of the colony."), _c('sup')]), _c('a', {
    attrs: {
      "id": "ch01en6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As a town’s population increased and home lots for new residents were established farther from the center of town, providing convenient access for these newer residents to their outlands, which were often some distance away, became increasingly difficult. In 1678, when a number of Guilford farmers found their fields landlocked by the property of others, the town appointed a committee to resolve the problem by mapping out an improved road system for the entire town. In many communities, however, the resolution of a private town way problem was often not as harmonious, with petitions and counterpetitions being debated for months."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("By the early eighteenth century, as land speculators began to exert an influence over the founding of new communities, the layout of new towns began to change. Eager for a quick return on their investment, speculators laid out an entire town at one time, incorporating two or more public town ways within their design. The size of home lots was also increased to ten acres or more, thereby bringing pasture and woodland within the boundaries of each home property. The result was a more dispersed community of family farms that eliminated many of the difficulties associated with the laying out of private town ways in earlier communities. This new concept of land division continued into the third phase of settlement."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("For most of the colonial period, the private town way problem remained a local issue, with a town’s board of selectmen being the final arbiters of the peace. In 1773, however, the laws of the colony were amended to allow dissatisfied petitioners to appeal a town’s decision concerning a private way to the county court, which then had the power to reverse that decision, lay out the road as it saw fit, and allocate the expense of construction to the individual who was to benefit from the road. The petitioner could then pay the assigned cost in either money or land."), _c('sup')]), _c('a', {
    attrs: {
      "id": "ch01en9"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The construction of country ways between towns was particularly problematic. Because Connecticut towns were to a great extent self-sufficient, providing adequate roads from town to town was of little interest to many communities. When a need became apparent for a country way between an inland town and a coastal port, for example, intervening towns usually resented the clearing and maintaining of a road through their community for which they might have little need. As a result, the clearing of intertown roads was frequently accomplished only after an order from the General Court. As with other roads, the laying out of country ways was originally a town responsibility, but as neglect and a lack of cooperation between towns became the norm, in 1702 the job of laying out country roads was given to the county court. The General Court decided the location of country ways that crossed from one county into another."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The first country way to be mentioned in the records of the Connecticut colony was a road between Hartford and Windsor that the General Court ordered built in 1638. Through the early years of the colony, other country ways were initiated by the General Court between Hartford and New Haven; Hartford and Waterbury via Farmington; Hartford and Simsbury; Woodbury and Stratford; and Norwich and New London. In this way, despite the difficulties involved, a network of crude highways connecting newer towns with more established communities evolved, slowly but surely, as the colony expanded."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en11"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("The use of statute labor first appeared in the laws of Connecticut in 1643, and was revised periodically thereafter to require additional days of service under increasing penalties for noncompliance. As time went on, exemptions from roadwork were given to magistrates, selectmen, ministers, physicians, and others. To replenish the labor supply, the law was revised in 1750 to include Native Americans, mulattoes, and slaves among those subject to compulsory road service. Men who were able to buy their way out of their service by paying the appropriate fines did so, and the money was used to hire other workers in their place. Despite the efforts of the General Court to require adequate road-building in the colony, most men saw compulsory road work as a burden most of the time, and this attitude was reflected in the poor quality of the work performed. Still, compulsory statute labor remained the backbone of Connecticut road-building and maintenance throughout the colonial period."), _c('sup')]), _c('a', {
    attrs: {
      "id": "ch01en12"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Given the limitations of manual labor and homemade tools, the alignment of many roadways was chosen so as to avoid physical obstacles where possible, as the following remark in the town records of Cheshire indicates: “all difficulties about rocks, swamps and other impediments the surveyors and sizers shall have power to regulate by turning the highways a little out of a straight course as convenient.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en13"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Road construction usually amounted to little more than clear cutting a right-of-way of moderate width through forest and brush. If a marshy section proved too big to avoid, whole logs might be laid perpendicular to the direction of travel, with sand spread beneath and on top of the logs to create a travel surface through the muck. Such travelways were termed corduroy roads for their resemblance to the ribbed fabric, and not only made for a bumpy wagon ride but also presented a serious hazard to horses from the shifting of the logs."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en14"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img_24.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('i', [_vm._v("Corduroy road, Fairfield. Archeological evidence suggests that this timber road, built about 1750, provided access from the center of Fairfield to a gristmill located at the mouth of Ash Creek. (Cece Saunders. Courtesy of the Connecticut Historical Commission)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('h4', {
    staticClass: "head2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FERRIES AND BRIDGES")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Ferries have existed in Connecticut from the earliest days of the colony, many rivers and streams being too wide to cross by any other means. Ferries were also utilized at crossings where bridges, though feasible, were too costly to construct. Unlike the construction of a bridge, whose capital cost was a drain on a town’s treasury, a ferry was a low-cost alternative whose revenue income became an asset to the community. With Connecticut’s drowned coastline and multiple river systems, ferry crossings became a fact of life for the colonial traveler, especially in the southern and eastern portions of the colony.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("One of the earliest ferries in Connecticut was authorized by the General Court in 1641 to cross the Connecticut River at Windsor. Known as Bissell’s ferry for the family that ran it, it may not have come into operation until as late as 1648. The crossing connected the two halves of the town of Windsor. On the east side, the ferry landed at East Windsor Hill, where it met the Bay Path for travel north to Springfield, Massachusetts. A second ferry was authorized by the General Court of the New Haven colony in June 1645 to cross New Haven’s East (Quinnipiac) River. In addition to collecting a toll from each passenger—the amount of which decreased as the number of passengers carried per crossing increased—the operator of this ferry was also given several acres of land in a nearby oyster shell field for providing the service."), _c('sup')]), _c('a', {
    attrs: {
      "id": "ch01en15"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As settlement continued, additional ferries appeared. By 1700, there were nine major ferry crossings in the colony: on the Connecticut River at Windsor, Hartford, Wethersfield, Haddam, and Saybrook; on the Housatonic River at Stratford; on the Quinnipiac River at New Haven; and on the Thames River at New London and Norwich. Ferries were also established across the Sauga-tuck and Niantic rivers; these crossings were considered among the more hazardous in the colony."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en16"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The technology utilized by early Connecticut ferries varied from crossing to crossing. Most were scow-type, flat-bottomed boats that were either poled, rowed, or sailed across the water, or in the case of the Niantic ferry, pulled across using a rope line that spanned the river. The most ingenious crossing was at Windsor. Here a scow was attached to a cable-pulley system that was stretched across the river and firmly anchored to each shore, with the cable running through a pulley on the side of the ferry scow. After shoving off, the ferryman turned the boat at an angle to the current of the river, whose force moved the boat along the cable line much the way a sailboat tacks into the wind. On the return crossing, the angle of the boat to the flow of the water was simply reversed. Cadwell’s Ferry in Hartford, when first established, also made use of a cable and pulley system."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en17"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The right to operate a given ferry was granted by the General Court (or the town) as an exclusive privilege, which carried with it the responsibility to provide the service for a specified length of time, usually seven or ten years. In return, the operator was assured that no other ferry would be allowed in the vicinity of his crossing. As late as 1755, the court denied a petition for a ferry across the Connecticut River above Windsor because of its proximity to the existing Bissell ferry."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en18"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" The granting of such exclusive privilege was considered necessary to entice a ferryman to assume the cost and responsibility of providing what was a public service. Exclusive privilege remained a legal principle utilized by the General Court throughout the colonial period.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img_26.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('i', [_vm._v("Bissell’s Ferry, c. 1900, from George E. Wright, Crossing the Connecticut (1908).")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("The fare schedule for each ferry was set by the General Court when the ferry was first established, and toll rates depended on the nature of the crossing. Tolls were highest across the colony’s two widest crossings, the Thames River at New London and the Connecticut River at Saybrook—where a further surcharge was allowed for a winter crossing. In 1702, the court issued its first general law concerning ferries, which required all ferrymen to provide “good tight boats sufficient both for largeness, strength, and steadiness for the safe transportation of travelers and their horses and supplied with oars and other implements and men who are discreet, strong and skilled in rowing.” The statute was revised periodically during the eighteenth century."), _c('sup')]), _c('a', {
    attrs: {
      "id": "ch01en19"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One of Connecticut’s earliest bridges was authorized by the General Court in 1640, when it ordered “a strong sufficient cartt Bridge” to be built over the Little River in Hartford. The structure was to be “twelve footte wide bettwene the Rayles with Turned Ballesters over the Top.” The next year the General Court of the New Haven colony ordered two cart bridges to be built “as speedly as may bee” over the West and Mill rivers in New Haven. Other bridges built during the early years of the colony included a cart bridge twelve feet in width over the East River in Guilford (1648); a bridge along the country road from Hartford to Farmington (1648); a great bridge in Hartford raised by statute labor (1651); two bridges in Hockanum also built by statute labor (1663); a horse bridge over the Norwalk River built by Norwalk residents on order of the General Court (1680); a bridge over the Manuckete-suck River on the road from Saybrook to Killingworth built by the inhabitants of the towns through which the river flowed (1680); and a cart bridge between Wallingford and New Haven, the cost to be shared by the two towns in proportion to their grand lists (1692)."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en20"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Most early bridges were built using a simple timber structure known as a king post truss, first developed in medieval Europe. With stone abutments set against each shoreline, two hewn logs were placed across the span as stringers, and then a floor of planks was set atop the stringers parallel to the river. Each stringer was kept from sagging under its load by placing a center post at midspan. A diagonal member was then attached to each end of the bridge. For stability, a timber was sometimes also erected over the roadway to connect the center posts on either side of the bridge. Since the king post truss was similar to the truss work used in a house or barn roof, this basic bridge design was familiar to most village carpenters. For longer spans, a rectangular center section was inserted between the two diagonals of a king post design, thereby creating a queen post truss. King and queen post designs could be applied to spans of up to forty feet, which together with their ease of construction made them popular for bridges over small rivers and streams."), _c('sup')]), _c('a', {
    attrs: {
      "id": "ch01en21"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Lovelace dispatched the first post rider to Hartford in December 1672 with a letter outlining details of the new post service:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "nospace"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ext-para"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("This person that has undertaken the imployment I conceaved most proper, being both active, stout and indefatigable. He is sworne as to his fidelity. I have affixt an annuall sallery on him, which, together with the advantage of his letters and other small portable packes, may afford him a handsome livelyhood. Hartford is the first stage I have designed him to change his horse, where constantly I expect he should have a fresh one lye. All the letters outward shall be delivered gratis … and reciprocally, we expect all to us free. Each first Monday of the month he sets out from New York, and is to return within the month from Boston to us againe. The mail has divers baggs, according to the townes the letters are designed to, which are all sealed up till their arrivement, with the seale of the Secretarie’s Office, whose care it is on Saturday night to seale them up. Only by-letters are in the open bag, to dispense by the wayes. …  I shall only beg of you … to afford him directions where and to whom to make his application to upon his arrival in Boston; as likewise to afford him what letters you can to establish him in that imployment there. It would be much advantagious to our designe, if in the intervall you discoursed with some of the most able woodmen, to make out the best and most fascile way for a Post, which in process of tyme would be the King’s best highway."), _c('sup')]), _c('a', {
    attrs: {
      "id": "ch01en22"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Service began in earnest when the next post rider left New York on January 22, 1673, laden with “two port-mantles crammed with letters, sundry goods, and bags.” The rider traveled first to New Haven and Hartford, then along the Bay Path to Springfield, Brookfield, and Worcester in Massachusetts, and on to Boston, where he arrived two weeks later having covered a distance of 250 miles."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en23"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("The first postal service in the colonies had no sooner been established than it was interrupted by the Dutch takeover of New York in July 1673, and the violence of King Philip’s War in 1675, in which several towns along the post route in Massachusetts were destroyed. During this period of disruption, the General Court of Connecticut acted to expand postal service within the colony in 1674 by setting postal rates between Hartford and two dozen other Connecticut towns. Post riders in Connecticut were allowed free ferriage, along with an allotment for room and board on overnight runs, to be paid from the colony’s general fund."), _c('sup')]), _c('a', {
    attrs: {
      "id": "ch01en24"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In 1685, mail service was reestablished by Massachusetts Governor Edmund Andros, who was charged with uniting the New England colonies under one governorship. Although Andros’s attempt at unification failed, postal service was resumed under his administration along the upper post road from Boston to Springfield, Massachusetts, Hartford, and New Haven, and along the coast to Fairfield. The renewed service was later extended into New York."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en25"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A royal charter in 1691 revitalized postal service throughout the English colonies in North America along a route that extended from Baltimore, Maryland, to Portsmouth, Maine. This time, service through Connecticut passed along the shoreline from New Haven to Saybrook and on to Providence, Rhode Island, thereby establishing a major travel route across lower Connecticut from New York to Boston. The stops for this service included Baltimore, Philadelphia, New York, Saybrook, and Boston, with a different post rider assigned to each leg of the route. Service through Connecticut left New York once each week in summer (every other week in winter) and followed the shoreline route to Saybrook, where the New York rider swapped mailbags with the rider who had come down from Boston via Providence."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en26"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("By the turn of the century, with the settlement of the eastern uplands under way, a third postal route from New York to Boston appeared across central Connecticut. This middle route veered east from Hartford and continued diagonally across the Windham Hills to Bolton, Coventry, Tolland, and Woodstock. The exact path of this middle post road is debated, but its existence is attested to by Benjamin Wadsworth, who traveled the route on a trip from Albany to Boston via Hartford in 1694. Leaving Hartford one August morning, Wadsworth and six fellow travelers encountered a road that was “very rocky, bushy, in many places miry: we were not troubled with many mountains and hills; but tho our road was bad and long, being counted about 50 miles, yet we came to Woodstock about 8 of ye clock” in the evening."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en27"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("As postal service through the colony became more regular, demands were placed on towns along the three post routes to keep the King’s Highway in their town in good repair, including bridge and ferry crossings. To accomplish this, the General Court of the Connecticut colony required an extra day (or two) of statute labor from men living in those towns. But some of the towns refused to require such extra work time of their residents, resulting in complaints to the General Court about travel conditions along certain portions of the King’s Highway.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("The court reasserted its mandate in 1698, ordering towns along the three post roads to keep cleared “convenient highways as may be for the advantage of posts … with sufficient causeis and bridges as need shall require … with marks erected for direction of travailers where ways part.” The court also singled out the county of New London and the town of Stonington, where “difficultie doth arise either for want of stated highways or for want of clearing and repairing highways where stated, and erecting and maintaining sufficient bridges.” So recalcitrant was the county that the court empowered a committee of three men to force road construction or repair as was required “by all lawfull ways and means, and at the charge of the town in which the highway lies.”"), _c('sup')]), _c('a', {
    attrs: {
      "id": "ch01en28"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ext-para"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Friday, October 6th: about eight this morning, with Mr. Joshua Wheeler my new Guide … wee advanced on towards Seabrook. The Rodes all along this way are very bad, Incumbered with rocks and mountainos passages … after about eight miles Rideing, in going over a Bridge, under which the River Run very swift, my horse stumbled, and very narrowly ‘scaped falling over into the water, which extreemly frightened mee. …  From hence wee went pretty briskly forward, and arriv’d at Saybrook ferry about two of the Clock afternoon … and about seven at night come to Killingsworth … and Lodgd there that night.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ext-para"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Saturday, October 7th: wee set out early in the Morning … and we soon after came into the Rhode, and keeping still on, without anything further Remarkabell, about two a clock afternoon we arrived at New Haven, where I was received with all Possible Respects and civility. Here I discharged Mr. Wheeler with a reward to his satisfaction, and took some time to rest after so long and toilsome a Journey."), _c('sup')]), _c('a', {
    attrs: {
      "id": "ch01en29"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Sarah Knight spent six days traveling to New Haven on the first portion of her journey. She remained there with family for several months before resuming her trip to New York in early December. Sarah Knight finally arrived in New York after three more days on the road, but not before encountering “many and great difficulties, as Bridges which were exceeding high and very tottering and of vast Length, steep and Rocky Hills and precipices.” In the area of western Greenwich known as Horseneck, she traversed “a mountainous passage that almost broke my heart in ascending.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en30"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" Yet, difficult though it was, Sarah Knight’s overland journey could hardly have been attempted without the existence of the post service and the king’s best highway.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('i', [_vm._v("In the eighteenth century, the Connecticut economy expanded from one that was mainly agricultural to one in which market capitalism played a larger role, and an increase in trade produced a demand for more roads, ferries, and bridges.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('h4', {
    staticClass: "head2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE COLONY’S ECONOMY EXPANDS")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("During the first half of the eighteenth century, as the population of Connecticut continued to climb and settlers moved into the eastern and western uplands, the economy of the colony changed. As the population of older towns reached a level greater than that necessary for self-subsistence, larger amounts of farm produce, dairy products, cattle, horses, and livestock were available for trade to other colonies, in particular to the islands of the West Indies, where a ready demand existed for the kinds of subsistence products that Connecticut had to spare. In addition, as the last of Connecticut’s farmland was put to the plow, a land shortage developed that led the sons of established farm families to migrate north and west to Vermont, New York, and Ohio; or to find work outside the farm in small-scale industries, such as metal-working, clock repair, cloth-making, and distillation of rum.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("With this growth in trade and small-scale industry came disparities in wealth between farmer and merchant, merchant and trader. The economic transformation these changes represented was felt first in older, more established communities and later in other towns across the colony as settlement expanded. By the 1760s, the combination of increasing population and limited farmland had transformed the economy of Connecticut from one based largely on subsistence agriculture to one that included significant (and increasing) amounts of intercolony trade and small-scale manufacturing. Although this economic expansion directly involved no more than 10 percent of Connecticut’s work-age population, it concerned the trading of agricultural products and livestock throughout the colony and therefore impacted a large portion of the colony’s total population.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As part of the expansion, Connecticut towns began to differentiate themselves according to their economic function. First were urban centers such as Hartford, New Haven, Middletown, New London, and Norwich, port towns where merchants conducted trade directly with comparable ports outside the colony. Next were secondary centers, such as Windham, Danbury, Lebanon, and Litchfield, that acted as inland marketplaces where trade goods were collected from and dispersed to surrounding communities. In addition, ports like Glastonbury, Haddam, Fairfield, and Saybrook that traded outside the colony, but only for themselves, could also be considered secondary centers. Last of all were the mainly agricultural towns, such as Sharon, Simsbury, Hebron, and Woodstock, that traded surplus products for imported goods in secondary or urban centers. These inland farm towns constituted the majority of Connecticut communities.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("In each town, whatever its economic function, the local tavern was the prime location for conducting the business affairs of the community. Whereas a country town might have five such taverns, a secondary town supported twice that number and an urban center a dozen or more. By midcentury, as the initial settlement of the colony came to a close, no Connecticut man lived more than a three-mile walk from one of these economic watering holes, or from the flow of opportunity and ideas that they represented."), _c('sup')]), _c('a', {
    attrs: {
      "id": "ch01en31"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "head2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NEW ROADS, FERRIES, AND BRIDGES")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "para"
  }, [_vm._v("Connecticut’s economic expansion quite naturally had an impact on the colony’s transportation needs. The increasing activity associated with trade resulted in a growing volume of wagon and livestock traffic that required the construction of new roads, ferries, and bridges as well as the improvement of existing ones. In the same way that overland travel in the early days of the colony had largely been determined by the distance to the local gristmill, meetinghouse, and militia training field, overland travel in the eighteenth century was now largely influenced by the distance between inland town and market center and between market center and port town."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en32"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the decades up to 1750, most new roads in the colony appeared east of the Connecticut River, as towns in the Windham Hills sought access to the ports of Norwich and Stonington to trade their surplus produce; to Boston for surplus cattle; and to Providence for surplus butter. After 1750, the appearance of new roads shifted to the western uplands, where the excess grain of Litchfield County and the pig iron produced by Salisbury-area furnaces were hauled to the Hudson River for transport by water to New York. In addition, a new road from Newtown to Danbury was opened specifically for driving cattle to New York City. In 1761, an effort was made to divert this Hudson-bound traffic to the port of Derby by the construction of a cart road from Canaan to Derby and the removal of navigation hazards from the lower Housatonic River. The scheme failed. Travel to New York City remained easier via the Hudson. But the very attempt suggests the competitive spirit that was abroad in Connecticut in the years before the revolution."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en33"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Other road construction included the improvement of an existing road from Durham to Middletown to facilitate the shipment of horses and cattle to the West Indies and a road from Hartford to Albany via Simsbury, New Hartford, Norfolk, and Canaan, prompted by the need to transport troops and munitions westward during the French and Indian War."), _c('sup')]), _c('a', {
    attrs: {
      "id": "ch01en34"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As before, such intertown roads were constructed using statute labor under the supervision of highway surveyors. These newer country roads were still located along a path of least resistance, but in New London County, at least, an effort was made to improve their design by reducing the surface damage caused by flowing water. This was accomplished by constructing earthen bumps on the sloped portions of a road so as to direct rainwater off the roadway. These swells were often placed on a diagonal “to give less resistance to the wheels, & turn off the water more effectually & with the least injury” to the road. “Cavities on the sides, near the swells catch the wash, & retain the sediment,” which allowed the earth that accumulated in these cavities to be thrown back on the road “from time to time, upon the swells, or where it is most wanted,” thereby aiding in road repair."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en35"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ext-para"
  }, [_vm._v("When I was a lad of about seven or eight years of age [Governor Wolcott] used to go to Hartford by my fathers house dressed in a scarlet coat. My oldest brother with many others was mending the highway at Grindle Hill close by my fathers and it was the custom at the time and since in them parts for such people to keep a bottle of rum and offer every traveler which passed a dram. From which they expected a generious price for the dram and frequantly received as much as would buy a whole quart. On this day Governour Woolcutt passed that place who was saluted agreable to custom and gave them one copper only for the dram he drank. What makes me remember it so perfectly well was my oldest brother who was possessed with quite as much meanness as either my father or Governour Woolcutt brought the copper to my fathers and punched a hole thro’ it and got a piece of scarlet cloth and went and sat a post in the ground so near the road that every traveler must see it. I stood by and see him punch the hole in the copper and went with him to see them plant the post and nail the copper and scarlet rag and heared many invectives thrown out against him [Governor Wolcott] for his meanness.."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en36"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img_35.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('i', [_vm._v("Higganum Ferry, c. 1900, from George E. Wright, Crossing the Connecticut (1908).")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("With the increase in travel brought on by a developing market economy, additional ferry crossings also appeared throughout the colony. By 1750, the number of ferries in Connecticut had grown from eleven (fifty years earlier) to twenty-six, and would peak at thirty by the end of the eighteenth century. In 1764, the colony established its first ferry across Long Island Sound, from Norwalk to the town of Huntington on Long Island. In addition, some busier crossings began to operate two boats, one from either shore, and offered scheduled service as opposed to service on demand. As with highways, the towns in which the ferries operated retained responsibility for seeing that updated ferry regulations and fares set by the General Assembly were put into practice.."), _c('sup')]), _c('a', {
    attrs: {
      "id": "ch01en37"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("At the turn of the century, the operations of several heavily traveled ferry crossings were transferred from individual to town ownership, including ferries across the Housatonic River between Stratford and Milford (1791) and across the Connecticut River between Saybrook and Lyme (1794), Hartford and East Hartford (1805), and Middletown and Portland (1812). One reason for this transfer was the need to finance improvements at ferry landings and to provide larger boats to accommodate the wheeled carriages that had begun to appear on the roads. To equalize such service between two towns, operation and revenue were assigned to the town on one side for one direction and to the town on the other side for the other direction. Towns that operated their own ferries often used the toll revenue to subsidize the cost of their public schools or to pay for bridge repairs. Still, the majority of Connecticut ferries were operated by individuals under a grant of exclusive privilege."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en38"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("Besides additional ferry service, more than thirty bridges of note were built in Connecticut between 1720 and 1789. The construction material of choice remained timber, and the design was of the king post or queen post variety. With confidence gained from experience, bridge builders attempted longer spans by using multiple sections resting on a series of stone or timber piers built midstream. A multiple-span bridge with a total length of 250 feet was erected over the Quinebaug River at Norwich in 1728—at a height of twenty feet above the water, so as not to interfere with boat traffic. Additional multispan bridges were constructed in Derby, Lisbon, and Farmington."), _c('sup')]), _c('a', {
    attrs: {
      "id": "ch01en39"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("On occasion, local businessmen who hoped to benefit from the construction of a particular bridge pooled their funds to build it, as was the case in Windsor in 1748, when three men were allowed to replace an existing ferry by building a cart bridge across the Rivulet, so long as the new structure remained “a free bridge forever.” More common were instances in which towns were admonished by the General Assembly for not paying sufficient attention to the condition of their bridges, particularly those located along intertown roads."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en40"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("As a result, alternative methods of financing were tried. One of the earliest was the use of bartered labor, in which an individual agreed to build or repair a particular bridge in return for a parcel of town land, or an exemption from his town taxes. This method was used in Woodstock in 1721, when Samuel Morris built and maintained three bridges in town in exchange for “being exempted from paying any rates whatsoever, whether country, town or ministry” for ten years; and in Pomfret, the following year, when John Sabin was granted three hundred acres of land in exchange “for his service in making of a bridge over Quinabaug River, on condition he keep the same in repair fourteen years next coming.” A variation on the bridge-for-land exchange occurred in 1759 in New Haven. There, the sewer commissioners of the town agreed to build a dike and dam across the East River, thereby making two thousand acres of marshy meadow land useable, if the proprietors of the meadow agreed, in turn, to build and maintain “a good and sufficient cart-bridge” near the dam to connect the two thousand acres to the town proper."), _c('sup')]), _c('a', {
    attrs: {
      "id": "ch01en41"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The toll bridge was considered an equitable solution to the problem of bridge financing, since it shifted the burden from the town as a whole to those who actually used the bridge, regardless of where they lived. As a result, toll collection became a common form of bridge financing, with the length of time a toll privilege was in effect varying from bridge to bridge. On occasion, toll privileges were granted in perpetuity, which meant that the town had to buy out the owner of the bridge at some future date should it ever want to free the crossing. Such was the case with the colony’s first toll crossing in Middletown; the town eventually purchased the bridge from the builder’s widow for two hundred acres of town-owned land sixty years after the toll was first established."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en42"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The toll collection method was used to finance the construction of bridges in Lyme (1731), Simsbury (1734), Norwich (1737), New Milford (1741), and Sharon-Cornwall (1757), among others. In Simsbury, where a group of men financed the construction of a toll bridge, the General Assembly afterward allowed them to form a proprietorship, complete with the election of officers and the holding of business meetings. This was an early and rare case of the corporation concept being used in colonial transportation. A similar bridge proprietorship was also authorized for a toll bridge in New Milford."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en43"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "99%",
      "src": "images/img_38.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('i', [_vm._v("Advertisement for a bridge lottery. (Courtesy of the Connecticut Historical Society, Hartford, Connecticut)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("Another popular way of raising bridge building funds in the second half of the eighteenth century was with a lottery. This method was first legalized in Connecticut in 1747 and was used thereafter to fund many public works projects, including bridge construction. Lotteries were used to build a bridge in Windsor in 1762 and one across Norwich Cove in 1772. By the end of the century, lotteries had been used in the construction or repair of more than a dozen bridges throughout Connecticut."), _c('sup')]), _c('a', {
    attrs: {
      "id": "ch01en44"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In situations where a bridge crossed the boundary between two towns, and the towns could not agree on the need for or method of construction— often because they did not want to pay for the work—the matter was referred to the county court for resolution. If the court agreed that the crossing or repair was necessary, the selectmen of the towns involved were ordered to complete the work. Beginning in 1761, such towns were allowed to levy a tax on their grand list to raise the necessary bridge funds. Once built, the bridge was typically maintained by the two towns in proportion to their grand lists. Later, towns were allowed to levy a bridge tax for an expensive reconstruction even if the structure did not cross a town boundary."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en45"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "head2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POST ROAD DEVELOPMENTS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("Because of the difficult travel conditions encountered along the eastern portion of the lower Post Road, Connecticut and Rhode Island acted jointly to reroute the King’s Highway between New London and Providence away from the shoreline and through Norwich instead, thereby avoiding both the inconvenience of a Thames River ferry crossing and the stony road conditions that existed east of New London. When completed in 1714, this inland branch of the lower Post Road from Norwich through Voluntown and Preston became the locally preferred route to and from Providence for the remainder of the century."), _c('sup')]), _c('a', {
    attrs: {
      "id": "ch01en46"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the summer of 1753, Benjamin Franklin traveled the lower Post Road through Connecticut while touring New England as the new deputy postmaster of the English colonies. In an effort to standardize postal rates according to distance traveled, Franklin and several assistants drove the lower post route in a carriage and placed stone markers at each mile point. In 1761, the colony’s General Assembly ordered towns located on any post route in Connecticut to erect stone markers along the side of the road that were at least two feet high and indicated the distance to the county seat. As with the increasing number of bridges and ferries, the placement of milestones along the colony’s post roads was another indication of the increase in traffic generated by the colony’s growing population and expanding economy."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en47"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ext-para"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("This man … at 72 is strong and robust, he has been in the service 46 years. …  It is well known that he has made an estate by his riding. …  He does much business on the road on commission, he is a publick carrier, and loads his horse with merchandise for people living in his route; he receives cash, and carry’s money backwards and forwards, takes care of return’d horses, and in short refuses no business however it may affect his speed as Post."), _c('sup')]), _c('a', {
    attrs: {
      "id": "ch01en48"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "para"
  }, [_vm._v("The earliest public transportation in the Connecticut colony (other than ferries) appeared in 1717, when Captain John Munson of New Haven, an officer in the local militia, was given permission by the General Assembly “to set up a waggon, to pass and transport passengers and goods between Hartford and New Haven.” As with most ferries, Munson was given a seven-year grant of exclusive privilege to operate the service, provided that he made at least one round trip per month (except in winter) and completed each round trip within one week. Should someone infringe on Munson’s privilege by charging a fee to carry freight between these two towns, he could be fined. Likewise, should Munson not meet the terms of his grant, he too was subject to a fine."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en49"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Unfortunately, little more is known of Munson’s operation, which likely traveled the Post Road from New Haven to Hartford. The rising level of economic activity suggests that similar wagon services existed in other parts of the colony. One such wagon service is thought to have run from Norwich to Providence along the inland route of the lower post road. Another may have operated about this time in northeastern Connecticut from Pomfret to Providence. Such were conditions in eastern Connecticut that the thirty-six miles from Pomfret to Providence, half a day’s journey on horseback, required two days by wagon."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en50"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("Stagecoach services first appeared in Connecticut in the 1760s, and focused mainly on travel between New York and Boston via the upper post road. The service began as a two-week round trip, but was sufficiently popular for the proprietor to increase the service to two trips per week to and from each city. The cost was 3 pence per mile, or about 3 pounds for the journey from New York to Boston. Stagecoach service was also begun along the north shore of Long Island from New York to Sag Harbor, where packet boats were available for the crossing to New London. Once in Connecticut, passengers could continue their stagecoach journey to Providence, and on to Boston. This combination land-sea-land route avoided both the difficult river crossings along the shoreline in Connecticut and a rough and stormy sea voyage around Point Judith. Stagecoach service also originated around this time along two different routes between Providence and Hartford."), _c('sup')]), _c('a', {
    attrs: {
      "id": "ch01en51"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The wagon-like stagecoach of the eighteenth century was little more than a large wooden box on springs. A canvas or leather top with windowless side flaps provided the only protection from rain and cold. Seats were of the bench variety, and often had no backs. Without a side entrance, passengers had to climb over the driver and one another to enter or exit the vehicle. And the ride over the rough and ready roads of colonial Connecticut was bone-jarring to be sure. Yet such was the demand for travel on the eve of the revolution that even such crude services were attempted and utilized."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en52"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "para"
  }, [_c('i', [_vm._v("Following the expulsion of the French from North America, the tax policy of King George III turned the desire for continued economic expansion in the American colonies into a call for political independence.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "head2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ROADS TO INDEPENDENCE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("The war impacted Connecticut transportation in several ways. With communities along Long Island Sound, such as Fairfield, New Haven, and New London, open to invasion by sea, wartime activities such as the collection and distribution of troops and supplies shifted to inland towns. As a result, enterprising businessmen looking to profit from these activities gravitated to Norwich, Hartford, Windsor, Litchfield, and Danbury, adding to the economic stature of these towns."), _c('sup')]), _c('a', {
    attrs: {
      "id": "ch01en53"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The war also placed an added burden on Connecticut’s existing road network. Because of the colony’s position in the region, troops, cattle, and wagons loaded with provisions moved across Connecticut in all directions. One notable military expedition across Connecticut was the march of General Jean-Baptiste de Rochambeau and several regiments of French troops on their way to Yorktown. In the summer of 1781, Rochambeau led a group of some five hundred officers, four thousand infantry, and six hundred cavalry troops from Providence to Danbury via Voluntown, Windham, Hartford, Southington, and Middlebury. Marching twelve to fifteen miles a day, the troops traveled with a train of two hundred wagons, carrying tents, food, and other supplies, each wagon pulled by a team of six oxen. One can only imagine the impact of the army as they trampled across hundreds of miles of dirt roads in Connecticut."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en54"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("With most able-bodied men preoccupied with fighting the English, it was difficult to keep supply routes in even the most rudimentary repair using statutory labor. Even before the war, the General Assembly in 1774 had for the first time allowed towns to levy a highway tax to raise the funds needed to repair and maintain their roads and bridges. Permission first had to be requested from the General Assembly and was granted for a limited time only, usually three years. Before the start of hostilities, only one or two towns had made use of the new highway tax, but by the end of the war nearly half the towns in the colony had used the tax to fund road repairs. Most of these towns were located in the Connecticut River valley or along inland routes to Providence, Boston, and the Hudson River."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en55"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img_44.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('i', [_vm._v("This roadside monument in Southington marks one of the many locations where Rochambeau’s army camped in June 1781 on its march across Connecticut. (Photo by the author)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("After the war, the funding of highway repairs through direct taxation remained a popular idea. In an environment of economic independence, with commerce and moneymaking on the rise, the use of forced labor to fix roads seemed regressive, while a graduated tax based on the value of the property a man owned appeared a fair alternative. As a result, the number of towns petitioning the General Assembly for permission to levy a highway tax continued to rise even after the war ended, reaching a total of seventy-one towns by 1795, with several towns making use of the levy more than once. In that year, the legislature incorporated the principle of a town highway tax into the general laws of Connecticut, allowing each town the right to levy the tax any time it chose by majority vote. In that way, the highway tax gradually came to replace the medieval principle of statute labor as the accepted means of financing roadwork."), _c('sup')]), _c('a', {
    attrs: {
      "id": "ch01en56"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "head2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONNECTICUT CIRCA 18OO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("Generations of English settlers had altered the natural landscape of Connecticut dramatically. By 1800, forest coverage had been reduced by two-thirds, from 95 percent of the colony’s land area to 30 percent. As the habitats provided by this ancient forest had disappeared, so had the native wildlife, such as black bear, white-tailed deer, wolves, and beaver, all of which were in steep decline at the end of the colonial period. Other species, including the moose, mountain lion, passenger pigeon, and wild turkey, had nearly become extinct in Connecticut. Meanwhile, Connecticut’s Ninnimissi-nuwock people, whose way of life had been interwoven over thousands of years with the flora and fauna of this natural landscape, had likewise all but disappeared."), _c('sup')]), _c('a', {
    attrs: {
      "id": "ch01en57"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The natural landscape the first Puritans had considered “a hidious & desolate wildernes, full of wild beasts & wild men” had been replaced by a manmade landscape of family farms, church parishes, schools, and all manner of commerce and commercial buildings."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en58"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" For the purpose of governance, the landscape was now divided into more than one hundred separate communities, organized into eight counties, a patchwork of civil jurisdictions stitched together by some one thousand miles of unimproved but passable country roads, and several dozen bridge and ferry crossings. As noted in the "), _c('i', [_vm._v("American Gazetteer")]), _vm._v(" of 1804, Connecticut had become")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ext-para"
  }, [_vm._v("checkered with innumerable roads or highways crossing each other in every direction. A traveller in any of these roads, even in the most unsettled parts of the state, will seldom pass more than half a mile or a mile without finding a house, and a farm under such improvements, as to afford the necessaries for the support of a family. The whole state resembles a well cultivated garden."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en59"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img_46.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('i', [_vm._v("Connecticut c. 1780. This map by Dutch mapmakers Covens and Mortier shows Connecticut at the end of the colonial period, including the three post routes to Boston and their local variations. (Courtesy of the Library of Congress)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("The charters for these five cities transferred to them certain political decisions that had been the concern of the state government. In each city a mayor, aldermen, and a common council were empowered to govern in such matters as markets and commerce, jury service, highways and wharfs, fire protection, and public health, among others. Likewise, the mayor and aldermen sat once each month as a city court to hear certain judicial matters affecting their local jurisdictions."), _c('sup')]), _c('a', {
    attrs: {
      "id": "ch01en60"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch01en60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("As for transportation, Connecticut, like the nation of which it was now a part, emerged from the revolution precariously balanced between two worlds: a colonial past of minimal construction and shoestring financing of roads that had yet to produce an adequate highway network, especially along the hundreds of miles of intertown routes so essential to regional trade and travel, and an uncertain future of economic expansion that required the movement of more and heavier goods over greater distances, which required more and better roads, bridges, and ferries. Connecticut overcame this transportation dilemma through a legal revolution that was every bit as significant as the political one that made Connecticut a state.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c385f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 81
// module chunks = 0